/**
 * @generated SignedSource<<1b3cefbc4ec0132bfb57c6f6bf941ee8>>
 * @relayHash f89c69933ae9471924611545ddd62a0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f0bf68c77e053b8e651a5ed03ee86ae3fe826bc2a55e48726e8df946fdb9f082

import type { ConcreteRequest } from 'relay-runtime';
export type EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation$variables = {
  id: string;
  status: boolean;
  type: string;
};
export type EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation$data = {
  readonly setRecommendedPagesStatus: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation = {
  response: EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation$data;
  variables: EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "enableRecommendedPages",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SetRecommendedPagesStatusPayload",
    "kind": "LinkedField",
    "name": "setRecommendedPagesStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "SetRecommendedPagesStatusPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f89c69933ae9471924611545ddd62a0f",
    "id": "f0bf68c77e053b8e651a5ed03ee86ae3fe826bc2a55e48726e8df946fdb9f082",
    "metadata": {},
    "name": "EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation",
    "operationKind": "mutation",
    "text": "mutation EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation($type:String!,$id:ID!,$status:Boolean!){setRecommendedPagesStatus(input:{entityType:$type,entityId:$id,enableRecommendedPages:$status}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "8da3a885838e8c5312c947c1ce0177fe";

export default node;
